var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_171)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_297_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0331 6.02881H68.7158L45.3773 32.7032L72.8332 69.001H51.3354L34.4976 46.9866L15.2313 69.001H4.54221L29.505 40.4698L3.1665 6.02881H25.21L40.4299 26.1509L58.0331 6.02881ZM54.2838 62.6069H60.2032L21.9936 12.0871H15.6415L54.2838 62.6069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1214 46.6573L15.0045 68.501H5.64403L29.8813 40.799L30.1508 40.4911L29.9022 40.166L4.17833 6.52881H24.9613L40.0311 26.4525L40.4017 26.9424L40.8062 26.4801L58.26 6.52881H67.6139L45.001 32.374L44.733 32.6803L44.9785 33.0048L71.828 68.501H51.5825L34.8948 46.6828L34.5237 46.1976L34.1214 46.6573ZM53.8867 62.9107L54.0368 63.1069H54.2838H60.2032H61.2083L60.602 62.3053L22.3924 11.7854L22.2423 11.5871H21.9936H15.6415H14.6295L15.2443 12.3908L53.8867 62.9107Z",
    stroke: "#CB37FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_297_171",
    x: -12.7335,
    y: -9.87119,
    width: 101.467,
    height: 94.7722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_297_171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_297_171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e6a8c4713b6771f5c1b5fac8b89ea7b3.svg";
export { ForwardRef as ReactComponent };